<template>
  <div class="invitacion-container">
    <div class="invitacion-card">
      <img src="@/assets/t.png" alt="Sello decorativo" class="sello-decorativo" />

      <div class="flores-decorativas"></div>

      <h1 ref="titulo" class="titulo-principal"> </h1>
      <p ref="nombres" class="subtitulo">
       Isabella Zorrilla
      </p>
      <p ref="fecha" class="fecha">Abril • 11 • 2026</p>

      <div class="seccion-idiomas" ref="idiomaSeccion">
        <p class="instruccion">Por favor selecciona tu idioma.</p>
        <div class="opciones-idioma">
          <button @click="seleccionar('es')" class="btn-idioma">
            <span>Español </span>
          </button>
        <button 
  @click="seleccionar('en')" 
  class="btn-idioma"
>
  <span>English</span>
</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue';
import gsap from 'gsap';

export default {
  name: 'InvitacionIdioma',
  emits: ['idioma-seleccionado'],
  setup(_, { emit }) {
    const ramaIzquierda = ref(null);
    const ramaDerecha = ref(null);
    const titulo = ref(null);
    const nombres = ref(null);
    const ampersand = ref(null);
    const fecha = ref(null);
    const idiomaSeccion = ref(null);

    const seleccionar = (idioma) => {
      emit('idioma-seleccionado', idioma);
    };

    onMounted(() => {
      gsap.from(ramaIzquierda.value, {
        x: -200,
        opacity: 0,
        duration: 1.5,
        ease: 'power3.out',
      });

      gsap.from(ramaDerecha.value, {
        x: 200,
        opacity: 0,
        duration: 1.5,
        ease: 'power3.out',
        delay: 0.3,
      });

      gsap.timeline({ delay: 0.5 })
        .from(titulo.value, {
          opacity: 0,
          y: -30,
          duration: 1,
          ease: 'power2.out',
        })
        .from(nombres.value, {
          opacity: 0,
          y: 30,
          duration: 1.2,
          ease: 'back.out(1.7)',
        }, '-=0.5')
        .from(ampersand.value, {
          scale: 0,
          opacity: 0,
          duration: 0.6,
          ease: 'elastic.out(1, 0.5)',
        }, '-=1')
        .from(fecha.value, {
          opacity: 0,
          y: 20,
          duration: 1,
          ease: 'power2.out',
        }, '-=0.8')
        .from(idiomaSeccion.value, {
          opacity: 0,
          y: 20,
          duration: 1,
          ease: 'power2.out',
        }, '-=0.8');
    });

    return {
      seleccionar,
      ramaIzquierda,
      ramaDerecha,
      titulo,
      nombres,
      ampersand,
      fecha,
      idiomaSeccion,
    };
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700&family=Montserrat:wght@300;400;500&family=Dancing+Script:wght@700&display=swap');

.invitacion-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  margin-top: -60px;
  padding: 1.5rem;
  background-image: 
    linear-gradient(to bottom, rgba(0, 0, 0, 0.4) 60%, rgba(26, 29, 81, 0.6) 85%, rgba(31, 33, 61, 0.5) 100%),
    url('@/assets/Diseño sin título (7).jpg');
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  position: relative;
  overflow: hidden;
}

/* EFECTO GLACEADO (Glassmorphism) */
.invitacion-card {
  position: relative;
  padding: 80px 30px 50px;
  margin: 0 auto;
  border-radius: 40px; /* Bordes más suaves para el estilo glaceado */
  
  /* Color de fondo traslúcido */
  background: rgba(255, 255, 255, 0.08); 
  
  /* Desenfoque del fondo */
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  
  /* Borde fino y brillante */
  border: 1px solid rgba(255, 255, 255, 0.2);
  
  /* Sombra suave */
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3);
  
  text-align: center;
  width: 100%;
  max-width: 360px;
  z-index: 1;
}

.sello-decorativo {
  width: 130px;
  height: auto;
  position: absolute;
  top: -55px;
  left: 50%;
  transform: translateX(-50%);
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
  z-index: 2;
}

.titulo-principal {
  font-family: 'Dancing Script', cursive;
  font-size: 2.5rem;
  color: #ffffff;
  margin-bottom: 0.5rem;
  text-shadow: 0 2px 4px rgba(0,0,0,0.3);
}

.subtitulo {
  font-family: 'british', serif; /* Asegúrate que la fuente esté cargada */
  margin-top: 20px;
 
  font-size: 2.0;
  color: #c173a3; /* Tono dorado más elegante */
  margin-bottom: 0.9rem;
  font-weight: 400;
  text-shadow: 0 1px 2px rgba(0,0,0,0.5);
}

.fecha {
  font-family: 'Montserrat', sans-serif;
  font-size: 1.1rem;
  color: #f1f1f1;
  margin-bottom: 2rem;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.instruccion {
  font-family: 'Montserrat', sans-serif;
  font-size: 0.9rem;
  color: #d1d1d1;
  margin-bottom: 1.5rem;
}

.btn-idioma {
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 50px; /* Botones tipo píldora */
  color: #1a1d51;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  padding: 12px 25px;
  width: 100%;
  max-width: 200px;
  margin: 0 auto;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.btn-idioma:hover {
  background: #ffffff;
  transform: scale(1.05);
}

.opciones-idioma {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

@media (max-width: 480px) {
  .invitacion-card {
    padding: 70px 20px 40px;
    max-width: 320px;
  }
  .subtitulo {
    font-size: 1.8rem;
  }
}
</style>